import demosCommunity from '../content/qml/demos_community/demos_community'
import { demosCategories } from '../../content/demos/demonstrations_categories'

/**
 * This function returns mapping URLs and their back URLs for routes which don't follow the nested directory structure.
 * Pages which lie in this category are:
 * 1. Individual demos pages
 * 2. Demo category pages
 * 3. All what-is-* pages in sub-hubs
 * e.g.
 * - Back path for demos is: /qml/demos/example-demo -> /qml/demo-category-> /qml/demonstrations
 * - Back path for what-is-* pages: /qml/what-is-quantum-computing -> /qml/quantum-computing -> /qml
 */
export const getCustomBackLinks = () => {
  const customBackLinks: {
    [key: string]: string
  } = {
    '/qml/what-is-quantum-computing': '/qml/quantum-computing',
    '/qml/whatisqml': '/qml/quantum-machine-learning',
    '/qml/what-is-quantum-chemistry': '/qml/quantum-chemistry',
    '/qml/demos_submission': '/qml/demonstrations',
    [`/qml/${demosCommunity.category_slug}`]: '/qml/demonstrations',
  }
  return customBackLinks
}

const demoCategoryRoutes = demosCategories.map((demoCategory) => {
  return {
    path: `/${demoCategory.urlFragment}`,
    label: demoCategory.title,
  }
})

export const customRoutes = [
  {
    path: '/qml',
    label: 'Learn',
  },
  {
    path: '/demos',
    customPath: '/demonstrations',
    label: 'Demos',
  },
  {
    path: '/demonstrations',
    label: 'Demos',
  },
  {
    path: '/glossary',
    label: 'Key Concepts',
  },
  {
    path: '/datasets',
    label: 'Quantum Datasets',
  },
  {
    path: '/getting-started',
    label: 'Getting Started',
  },
  {
    path: '/optimization',
    label: 'Optimization',
  },
  ...demoCategoryRoutes,
]
